import React from "react";
import BgCut from "../../assets/about/bottomCircle.png";
import BgCutMobile from "../../assets/about/bottomCircleMobile.png";
// Desktop
// import SpineLine from "../../assets/about/line/spine.svg";
import IpfsLine from "../../assets/about/line/ipfs.svg";
import Web3Line from "../../assets/about/line/web3.svg";
import RustLine from "../../assets/about/line/rust.svg";
import MetaverseLine from "../../assets/about/line/metaverse.svg";
import SolidityLine from "../../assets/about/line/solidity.svg";
// Mobile
import Spine from "../../assets/about/line/spineline.png";
import Ipfs from "../../assets/about/line/ipfsline.png";
import Web3 from "../../assets/about/line/web3line.png";
import Rust from "../../assets/about/line/rustline.png";
import Metaverse from "../../assets/about/line/metaline.png";
import Solidity from "../../assets/about/line/solidityline.png";

function BlockChain() {
  return (
    <div className="fixed md:-bottom-[57%] lg:-bottom-[37%] -bottom-[54%] h-screen w-screen">
      <div className="relative h-full">
        <img
          src={BgCut}
          alt=""
          className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-full h-full hidden lg:block object-cover lg:object-contain"
        />
        <img
          src={BgCutMobile}
          alt=""
          className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-full h-full lg:hidden object-cover"
        />
        {/* Desktop */}

        {/* Left Side */}
        <div className="absolute text-white top-[18%] md:top-[20%] md:left-[33%] lg:top-[36%] left-[33%] lg:left-[37%] -translate-x-1/2 -translate-y-[45%] ">
          <span className="text-white font-bold -ml-[25%] md:-ml-[80%] -translate-x-1/2 text-xs md:text-md leading-10 text-md sm:hidden">
            SPINE
          </span>
          <img
            src={RustLine}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[62%] md:w-full h-full -scale-x-100 sm:hidden "
          />
        </div>
        <div className="absolute text-white top-[25%] md:top-[25%] md:left-[23%]  lg:top-[44%] left-[25%] lg:left-[35%] -translate-x-1/2 -translate-y-[45%] sm:hidden">
          <span className="text-white  font-bold -ml-[45%] md:-ml-[60%] -translate-x-1/2 text-xs md:text-md leading-10 text-md">
            IPFS
          </span>
          <img
            src={IpfsLine}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[62%] md:w-[90%] h-full"
          />
        </div>
        <div className="absolute text-white top-[33%] md:top-[33%] md:left-[15%] lg:top-[54%] left-[20%] lg:left-[30%] -translate-x-1/2 -translate-y-[45%] sm:hidden">
          <span className="text-white font-bold -ml-[40%] md:-ml-[55%] -translate-x-1/2 text-xs md:text-md leading-10 text-md">
            WEB3
          </span>
          <img
            src={Web3Line}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[62%] md:w-[80%] h-full"
          />
        </div>

        {/* Right Side */}
        <div className="absolute text-white top-[18%] md:top-[20%] md:-right-[3%] lg:top-[36%] -right-[46%] lg:right-[16%] xl:right-[25%] 2xl:right-[19%] -translate-x-1/2 -translate-y-[45%] sm:hidden">
          <span className="text-white font-bold ml-[40%] md:-mr-[50%] -translate-x-1/2 text-xs md:text-md leading-10 text-md">
            RUST
          </span>
          <img
            src={RustLine}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[62%] md:w-full h-full"
          />
        </div>
        <div className="absolute text-white top-[24%] md:top-[27%] md:-right-[18%] lg:top-[42%] -right-[46%] lg:right-[6%] xl:right-[15%] -translate-x-1/2 -translate-y-[45%] sm:hidden">
          <span className="text-white font-bold  ml-[40%] md:-mr-[35%] -translate-x-1/2 text-xs md:text-md leading-10 text-md">
            METAVERSE
          </span>
          <img
            src={MetaverseLine}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[42%] md:w-full h-full"
          />
        </div>
        <div className="absolute text-white top-[32%] md:top-[36%] md:-right-[12%]  lg:top-[54%] -right-[36%] lg:right-[11%] xl:right-[15%] -translate-x-1/2 -translate-y-[45%] sm:hidden">
          <span className="text-white font-bold  ml-[40%] md:-mr-[35%] -translate-x-1/2 text-xs md:text-md leading-10 text-md">
            SOLIDITY
          </span>
          <img
            src={SolidityLine}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[62%] md:w-full h-full"
          />
        </div>

        {/* Mobile */}

        {/* Left Side */}
        <div className="absolute text-white top-[19%] left-[38%] -translate-x-1/2 -translate-y-[45%]  md:hidden lg:hidden xl:hidden 2xl:hidden">
          <span className="text-white font-bold -ml-[25%] -translate-x-1/2 text-xs leading-8 text-md">
            SPINE
          </span>
          <img
            src={Spine}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[62%] h-full "
          />
        </div>
        <div className="absolute text-white top-[24%] left-[25%] -translate-x-1/2 -translate-y-[45%] md:hidden lg:hidden xl:hidden 2xl:hidden">
          <span className="text-white font-bold -translate-x-1/2 text-xs leading-8 text-md">
            IPFS
          </span>
          <img
            src={Ipfs}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[62%] h-full"
          />
        </div>
        <div className="absolute text-white top-[29%] left-[16%] -translate-x-1/2 -translate-y-[45%] md:hidden lg:hidden xl:hidden 2xl:hidden">
          <span className="text-white font-bold -ml-[40%] -translate-x-1/2 text-xs leading-8 text-md">
            WEB3
          </span>
          <img
            src={Web3}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[62%] h-full"
          />
        </div>

        {/* Right Side */}
        <div className="absolute text-white top-[18%] right-[8%] -translate-x-1/2 -translate-y-[45%] md:hidden lg:hidden xl:hidden 2xl:hidden">
          <span className="text-white font-bold ml-[40%] -translate-x-1/2 text-xs leading-8 text-md">
            RUST
          </span>
          <img
            src={Rust}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[62%] h-full"
          />
        </div>
        <div className="absolute text-white top-[22%] right-[7%] -translate-x-1/2 -translate-y-[45%] md:hidden lg:hidden xl:hidden 2xl:hidden">
          <span className="text-white font-bold ml-[40%] -translate-x-1/2 text-xs leading-8 text-md">
            METAVERSE
          </span>
          <img
            src={Metaverse}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[42%] h-full"
          />
        </div>
        <div className="absolute text-white top-[26%] -right-[3%] -translate-x-1/2 -translate-y-[45%] md:hidden lg:hidden xl:hidden 2xl:hidden">
          <span className="text-white font-bold ml-[40%] -translate-x-1/2 text-xs leading-8 text-md">
            SOLIDITY
          </span>
          <img
            src={Solidity}
            alt=""
            className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-[62%] h-full"
          />
        </div>

        <div className="absolute text-white top-[35%] md:top-[54%] left-1/2 -translate-x-1/2 -translate-y-1/2 ">
          <span className="text-white font-bold -translate-x-1/2 md:text-md leading-10 text-sm font-bold">
            BLOCKCHAIN
          </span>
        </div>
      </div>
    </div>
  );
}

export default BlockChain;
